const data = {
  programmeData: [
    {
      show: "EastEnders",
      show_type: "British Soap",
      show_hashtag: "#eastenders",
      num_stressed_tweets: 36818,
      max_number: 36818,
      stressed_word_counts: [
        { name: "bad", count: 2011 },
        { name: "omg", count: 3296 },
        { name: "cry", count: 1052 },
        { name: "hate", count: 1708 },
        { name: "damn", count: 543 },
        { name: "crazy", count: 275 },
        { name: "crying", count: 647 },
        { name: "annoying", count: 681 },
        { name: "sad", count: 1671 },
        { name: "horrible", count: 460 },
        { name: "wtf", count: 824 },
        { name: "terrible", count: 267 },
        { name: "awful", count: 550 },
        { name: "sick", count: 1036 },
        { name: "disgusting", count: 332 },
        { name: "shock", count: 1094 },
        { name: "weird", count: 648 },
        { name: "shocked", count: 420 },
        { name: "crap", count: 323 },
        { name: "emotional", count: 605 },
        { name: "angry", count: 526 },
        { name: "dead", count: 2291 },
        { name: "worried", count: 478 },
        { name: "scary", count: 144 },
        { name: "death", count: 2164 },
        { name: "screaming", count: 184 },
        { name: "bloody", count: 1207 },
        { name: "creepy", count: 150 },
        { name: "killed", count: 2297 },
        { name: "died", count: 784 },
        { name: "cried", count: 102 },
        { name: "scared", count: 408 },
        { name: "dark", count: 528 },
        { name: "murder", count: 1603 },
        { name: "heartbreaking", count: 834 },
        { name: "disturbing", count: 74 },
        { name: "horrific", count: 170 },
        { name: "brutal", count: 208 },
        { name: "cope", count: 235 },
        { name: "saddest", count: 31 },
        { name: "devastated", count: 169 },
        { name: "depressed", count: 61 },
        { name: "depressing", count: 180 },
        { name: "terrifying", count: 87 },
        { name: "devastating", count: 300 },
        { name: "excruciating", count: 7 },
        { name: "disturbed", count: 25 },
        { name: "distraught", count: 40 },
        { name: "despair", count: 19 },
        { name: "traumatised", count: 42 },
        { name: "morbid", count: 11 },
      ],
    },
    {
      show: "Coronation Street",
      show_type: "British Soap",
      show_hashtag: "#corrie",
      num_stressed_tweets: 29918,
      max_number: 36818,
      stressed_word_counts: [
        { name: "bad", count: 1677 },
        { name: "omg", count: 2405 },
        { name: "cry", count: 746 },
        { name: "hate", count: 1455 },
        { name: "damn", count: 230 },
        { name: "crazy", count: 162 },
        { name: "crying", count: 481 },
        { name: "annoying", count: 1193 },
        { name: "sad", count: 1276 },
        { name: "horrible", count: 601 },
        { name: "wtf", count: 480 },
        { name: "terrible", count: 326 },
        { name: "awful", count: 667 },
        { name: "sick", count: 620 },
        { name: "disgusting", count: 310 },
        { name: "shock", count: 651 },
        { name: "weird", count: 497 },
        { name: "shocked", count: 173 },
        { name: "crap", count: 409 },
        { name: "emotional", count: 532 },
        { name: "angry", count: 267 },
        { name: "dead", count: 1571 },
        { name: "worried", count: 270 },
        { name: "scary", count: 135 },
        { name: "death", count: 1457 },
        { name: "screaming", count: 155 },
        { name: "bloody", count: 1997 },
        { name: "creepy", count: 183 },
        { name: "killed", count: 846 },
        { name: "died", count: 576 },
        { name: "cried", count: 75 },
        { name: "scared", count: 282 },
        { name: "dark", count: 472 },
        { name: "murder", count: 963 },
        { name: "heartbreaking", count: 1246 },
        { name: "disturbing", count: 51 },
        { name: "horrific", count: 158 },
        { name: "brutal", count: 206 },
        { name: "cope", count: 286 },
        { name: "saddest", count: 33 },
        { name: "devastated", count: 164 },
        { name: "depressed", count: 27 },
        { name: "depressing", count: 160 },
        { name: "terrifying", count: 83 },
        { name: "devastating", count: 256 },
        { name: "excruciating", count: 8 },
        { name: "disturbed", count: 13 },
        { name: "distraught", count: 29 },
        { name: "despair", count: 24 },
        { name: "traumatised", count: 39 },
        { name: "morbid", count: 6 },
      ],
    },
    {
      show: "Emmerdale",
      show_type: "British Soap",
      show_hashtag: "#emmerdale",
      num_stressed_tweets: 20427,
      max_number: 36818,
      stressed_word_counts: [
        { name: "bad", count: 1426 },
        { name: "omg", count: 1127 },
        { name: "cry", count: 415 },
        { name: "hate", count: 893 },
        { name: "damn", count: 273 },
        { name: "crazy", count: 172 },
        { name: "crying", count: 251 },
        { name: "annoying", count: 978 },
        { name: "sad", count: 473 },
        { name: "horrible", count: 328 },
        { name: "wtf", count: 375 },
        { name: "terrible", count: 263 },
        { name: "awful", count: 411 },
        { name: "sick", count: 566 },
        { name: "disgusting", count: 341 },
        { name: "shock", count: 634 },
        { name: "weird", count: 363 },
        { name: "shocked", count: 158 },
        { name: "crap", count: 460 },
        { name: "emotional", count: 296 },
        { name: "angry", count: 289 },
        { name: "dead", count: 1219 },
        { name: "worried", count: 257 },
        { name: "scary", count: 89 },
        { name: "death", count: 1151 },
        { name: "screaming", count: 99 },
        { name: "bloody", count: 1075 },
        { name: "creepy", count: 132 },
        { name: "killed", count: 719 },
        { name: "died", count: 354 },
        { name: "cried", count: 23 },
        { name: "scared", count: 232 },
        { name: "dark", count: 410 },
        { name: "murder", count: 885 },
        { name: "heartbreaking", count: 194 },
        { name: "disturbing", count: 29 },
        { name: "horrific", count: 61 },
        { name: "brutal", count: 154 },
        { name: "cope", count: 138 },
        { name: "saddest", count: 6 },
        { name: "devastated", count: 134 },
        { name: "depressed", count: 21 },
        { name: "depressing", count: 110 },
        { name: "terrifying", count: 29 },
        { name: "devastating", count: 221 },
        { name: "excruciating", count: 4 },
        { name: "disturbed", count: 23 },
        { name: "distraught", count: 42 },
        { name: "despair", count: 27 },
        { name: "traumatised", count: 18 },
        { name: "morbid", count: 6 },
      ],
    },
    {
      show: "Hollyoaks",
      show_type: "British Soap",
      show_hashtag: "#hollyoaks",
      num_stressed_tweets: 14932,
      max_number: 36818,
      stressed_word_counts: [
        { name: "bad", count: 915 },
        { name: "omg", count: 1498 },
        { name: "cry", count: 449 },
        { name: "hate", count: 846 },
        { name: "damn", count: 290 },
        { name: "crazy", count: 210 },
        { name: "crying", count: 313 },
        { name: "annoying", count: 332 },
        { name: "sad", count: 348 },
        { name: "horrible", count: 176 },
        { name: "wtf", count: 329 },
        { name: "terrible", count: 139 },
        { name: "awful", count: 223 },
        { name: "sick", count: 371 },
        { name: "disgusting", count: 260 },
        { name: "shock", count: 524 },
        { name: "weird", count: 214 },
        { name: "shocked", count: 120 },
        { name: "crap", count: 92 },
        { name: "emotional", count: 247 },
        { name: "angry", count: 159 },
        { name: "dead", count: 1254 },
        { name: "worried", count: 167 },
        { name: "scary", count: 78 },
        { name: "death", count: 658 },
        { name: "screaming", count: 80 },
        { name: "bloody", count: 311 },
        { name: "creepy", count: 266 },
        { name: "killed", count: 982 },
        { name: "died", count: 260 },
        { name: "cried", count: 41 },
        { name: "scared", count: 204 },
        { name: "dark", count: 194 },
        { name: "murder", count: 637 },
        { name: "heartbreaking", count: 123 },
        { name: "disturbing", count: 21 },
        { name: "horrific", count: 53 },
        { name: "brutal", count: 76 },
        { name: "cope", count: 80 },
        { name: "saddest", count: 15 },
        { name: "devastated", count: 35 },
        { name: "depressed", count: 11 },
        { name: "depressing", count: 9 },
        { name: "terrifying", count: 40 },
        { name: "devastating", count: 134 },
        { name: "excruciating", count: 2 },
        { name: "disturbed", count: 5 },
        { name: "distraught", count: 12 },
        { name: "despair", count: 1 },
        { name: "traumatised", count: 3 },
        { name: "morbid", count: 3 },
      ],
    },
    {
      show: "Euro 2020",
      show_type: "Live Event",
      show_hashtag: "#euro2020",
      num_stressed_tweets: 126652,
      max_number: 126652,
      stressed_word_counts: [
        { name: "bad", count: 10957 },
        { name: "omg", count: 4705 },
        { name: "cry", count: 4216 },
        { name: "hate", count: 5977 },
        { name: "damn", count: 4384 },
        { name: "crazy", count: 4778 },
        { name: "crying", count: 2603 },
        { name: "annoying", count: 964 },
        { name: "sad", count: 4742 },
        { name: "horrible", count: 2656 },
        { name: "wtf", count: 4062 },
        { name: "terrible", count: 4119 },
        { name: "awful", count: 4307 },
        { name: "sick", count: 1851 },
        { name: "disgusting", count: 2332 },
        { name: "shock", count: 3420 },
        { name: "weird", count: 1560 },
        { name: "shocked", count: 971 },
        { name: "crap", count: 1316 },
        { name: "emotional", count: 1867 },
        { name: "angry", count: 645 },
        { name: "dead", count: 4151 },
        { name: "worried", count: 980 },
        { name: "scary", count: 1054 },
        { name: "death", count: 9264 },
        { name: "screaming", count: 934 },
        { name: "bloody", count: 5267 },
        { name: "creepy", count: 35 },
        { name: "killed", count: 589 },
        { name: "died", count: 899 },
        { name: "cried", count: 241 },
        { name: "scared", count: 928 },
        { name: "dark", count: 4396 },
        { name: "murder", count: 270 },
        { name: "heartbreaking", count: 1149 },
        { name: "disturbing", count: 142 },
        { name: "horrific", count: 584 },
        { name: "brutal", count: 1855 },
        { name: "cope", count: 1183 },
        { name: "saddest", count: 60 },
        { name: "devastated", count: 481 },
        { name: "depressed", count: 84 },
        { name: "depressing", count: 191 },
        { name: "terrifying", count: 221 },
        { name: "devastating", count: 334 },
        { name: "excruciating", count: 64 },
        { name: "disturbed", count: 20 },
        { name: "distraught", count: 172 },
        { name: "despair", count: 216 },
        { name: "traumatised", count: 44 },
        { name: "morbid", count: 5 },
      ],
    },
    {
      show: "F1",
      show_type: "Live Event",
      show_hashtag: "#f1",
      num_stressed_tweets: 73469,
      max_number: 126652,
      stressed_word_counts: [
        { name: "bad", count: 8759 },
        { name: "omg", count: 2829 },
        { name: "cry", count: 2204 },
        { name: "hate", count: 2799 },
        { name: "damn", count: 2953 },
        { name: "crazy", count: 4635 },
        { name: "crying", count: 1358 },
        { name: "annoying", count: 482 },
        { name: "sad", count: 4683 },
        { name: "horrible", count: 1490 },
        { name: "wtf", count: 4868 },
        { name: "terrible", count: 2151 },
        { name: "awful", count: 1339 },
        { name: "sick", count: 759 },
        { name: "disgusting", count: 590 },
        { name: "shock", count: 1910 },
        { name: "weird", count: 1540 },
        { name: "shocked", count: 614 },
        { name: "crap", count: 859 },
        { name: "emotional", count: 1215 },
        { name: "angry", count: 844 },
        { name: "dead", count: 1023 },
        { name: "worried", count: 750 },
        { name: "scary", count: 1558 },
        { name: "death", count: 1077 },
        { name: "screaming", count: 416 },
        { name: "bloody", count: 1983 },
        { name: "creepy", count: 39 },
        { name: "killed", count: 1018 },
        { name: "died", count: 1016 },
        { name: "cried", count: 157 },
        { name: "scared", count: 408 },
        { name: "dark", count: 601 },
        { name: "murder", count: 235 },
        { name: "heartbreaking", count: 490 },
        { name: "disturbing", count: 43 },
        { name: "horrific", count: 941 },
        { name: "brutal", count: 1272 },
        { name: "cope", count: 894 },
        { name: "saddest", count: 61 },
        { name: "devastated", count: 202 },
        { name: "depressed", count: 51 },
        { name: "depressing", count: 106 },
        { name: "terrifying", count: 557 },
        { name: "devastating", count: 149 },
        { name: "excruciating", count: 16 },
        { name: "disturbed", count: 14 },
        { name: "distraught", count: 25 },
        { name: "despair", count: 47 },
        { name: "traumatised", count: 14 },
        { name: "morbid", count: 15 },
      ],
    },
    {
      show: "The Chase",
      show_type: "Quiz",
      show_hashtag: "#thechase",
      num_stressed_tweets: 11855,
      max_number: 11855,
      stressed_word_counts: [
        { name: "bad", count: 1205 },
        { name: "omg", count: 510 },
        { name: "cry", count: 148 },
        { name: "hate", count: 487 },
        { name: "damn", count: 432 },
        { name: "crazy", count: 137 },
        { name: "crying", count: 79 },
        { name: "annoying", count: 770 },
        { name: "sad", count: 235 },
        { name: "horrible", count: 109 },
        { name: "wtf", count: 478 },
        { name: "terrible", count: 214 },
        { name: "awful", count: 265 },
        { name: "sick", count: 133 },
        { name: "disgusting", count: 87 },
        { name: "shock", count: 220 },
        { name: "weird", count: 256 },
        { name: "shocked", count: 123 },
        { name: "crap", count: 348 },
        { name: "emotional", count: 27 },
        { name: "angry", count: 125 },
        { name: "dead", count: 307 },
        { name: "worried", count: 67 },
        { name: "scary", count: 64 },
        { name: "death", count: 133 },
        { name: "screaming", count: 77 },
        { name: "bloody", count: 1490 },
        { name: "creepy", count: 47 },
        { name: "killed", count: 74 },
        { name: "died", count: 123 },
        { name: "cried", count: 8 },
        { name: "scared", count: 75 },
        { name: "dark", count: 467 },
        { name: "murder", count: 62 },
        { name: "heartbreaking", count: 8 },
        { name: "disturbing", count: 9 },
        { name: "horrific", count: 20 },
        { name: "brutal", count: 108 },
        { name: "cope", count: 27 },
        { name: "saddest", count: 4 },
        { name: "devastated", count: 37 },
        { name: "depressed", count: 4 },
        { name: "depressing", count: 21 },
        { name: "terrifying", count: 16 },
        { name: "devastating", count: 4 },
        { name: "excruciating", count: 4 },
        { name: "disturbed", count: 1 },
        { name: "distraught", count: 2 },
        { name: "despair", count: 19 },
        { name: "traumatised", count: 7 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "Tipping Point",
      show_type: "Quiz",
      show_hashtag: "#tippingpoint",
      num_stressed_tweets: 7475,
      max_number: 11855,
      stressed_word_counts: [
        { name: "bad", count: 607 },
        { name: "omg", count: 303 },
        { name: "cry", count: 117 },
        { name: "hate", count: 287 },
        { name: "damn", count: 199 },
        { name: "crazy", count: 77 },
        { name: "crying", count: 75 },
        { name: "annoying", count: 791 },
        { name: "sad", count: 160 },
        { name: "horrible", count: 51 },
        { name: "wtf", count: 317 },
        { name: "terrible", count: 90 },
        { name: "awful", count: 137 },
        { name: "sick", count: 107 },
        { name: "disgusting", count: 21 },
        { name: "shock", count: 115 },
        { name: "weird", count: 105 },
        { name: "shocked", count: 60 },
        { name: "crap", count: 159 },
        { name: "emotional", count: 34 },
        { name: "angry", count: 73 },
        { name: "dead", count: 186 },
        { name: "worried", count: 64 },
        { name: "scary", count: 41 },
        { name: "death", count: 236 },
        { name: "screaming", count: 88 },
        { name: "bloody", count: 928 },
        { name: "creepy", count: 117 },
        { name: "killed", count: 37 },
        { name: "died", count: 111 },
        { name: "cried", count: 6 },
        { name: "scared", count: 32 },
        { name: "dark", count: 92 },
        { name: "murder", count: 50 },
        { name: "heartbreaking", count: 10 },
        { name: "disturbing", count: 20 },
        { name: "horrific", count: 13 },
        { name: "brutal", count: 54 },
        { name: "cope", count: 45 },
        { name: "saddest", count: 0 },
        { name: "devastated", count: 38 },
        { name: "depressed", count: 8 },
        { name: "depressing", count: 19 },
        { name: "terrifying", count: 15 },
        { name: "devastating", count: 8 },
        { name: "excruciating", count: 4 },
        { name: "disturbed", count: 2 },
        { name: "distraught", count: 4 },
        { name: "despair", count: 19 },
        { name: "traumatised", count: 4 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "Tenable",
      show_type: "Quiz",
      show_hashtag: "#tenable",
      num_stressed_tweets: 927,
      max_number: 11855,
      stressed_word_counts: [
        { name: "bad", count: 90 },
        { name: "omg", count: 49 },
        { name: "cry", count: 7 },
        { name: "hate", count: 22 },
        { name: "damn", count: 10 },
        { name: "crazy", count: 3 },
        { name: "crying", count: 7 },
        { name: "annoying", count: 60 },
        { name: "sad", count: 18 },
        { name: "horrible", count: 6 },
        { name: "wtf", count: 51 },
        { name: "terrible", count: 102 },
        { name: "awful", count: 45 },
        { name: "sick", count: 12 },
        { name: "disgusting", count: 4 },
        { name: "shock", count: 21 },
        { name: "weird", count: 23 },
        { name: "shocked", count: 9 },
        { name: "crap", count: 37 },
        { name: "emotional", count: 2 },
        { name: "angry", count: 5 },
        { name: "dead", count: 19 },
        { name: "worried", count: 11 },
        { name: "scary", count: 3 },
        { name: "death", count: 8 },
        { name: "screaming", count: 15 },
        { name: "bloody", count: 100 },
        { name: "creepy", count: 2 },
        { name: "killed", count: 1 },
        { name: "died", count: 5 },
        { name: "cried", count: 0 },
        { name: "scared", count: 3 },
        { name: "dark", count: 6 },
        { name: "murder", count: 2 },
        { name: "heartbreaking", count: 0 },
        { name: "disturbing", count: 0 },
        { name: "horrific", count: 3 },
        { name: "brutal", count: 5 },
        { name: "cope", count: 6 },
        { name: "saddest", count: 0 },
        { name: "devastated", count: 0 },
        { name: "depressed", count: 1 },
        { name: "depressing", count: 1 },
        { name: "terrifying", count: 0 },
        { name: "devastating", count: 0 },
        { name: "excruciating", count: 1 },
        { name: "disturbed", count: 0 },
        { name: "distraught", count: 1 },
        { name: "despair", count: 3 },
        { name: "traumatised", count: 0 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "Married at First Sight",
      show_type: "Reality TV",
      show_hashtag: "#marriedatfirstsight",
      num_stressed_tweets: 168356,
      max_number: 168356,
      stressed_word_counts: [
        { name: "bad", count: 0 },
        { name: "omg", count: 0 },
        { name: "cry", count: 0 },
        { name: "hate", count: 0 },
        { name: "damn", count: 0 },
        { name: "crazy", count: 0 },
        { name: "crying", count: 0 },
        { name: "annoying", count: 0 },
        { name: "sad", count: 0 },
        { name: "horrible", count: 0 },
        { name: "wtf", count: 0 },
        { name: "terrible", count: 0 },
        { name: "awful", count: 0 },
        { name: "sick", count: 0 },
        { name: "disgusting", count: 0 },
        { name: "shock", count: 0 },
        { name: "weird", count: 0 },
        { name: "shocked", count: 0 },
        { name: "crap", count: 0 },
        { name: "emotional", count: 0 },
        { name: "angry", count: 0 },
        { name: "dead", count: 0 },
        { name: "worried", count: 0 },
        { name: "scary", count: 0 },
        { name: "death", count: 0 },
        { name: "screaming", count: 0 },
        { name: "bloody", count: 0 },
        { name: "creepy", count: 0 },
        { name: "killed", count: 0 },
        { name: "died", count: 0 },
        { name: "cried", count: 0 },
        { name: "scared", count: 0 },
        { name: "dark", count: 0 },
        { name: "murder", count: 0 },
        { name: "heartbreaking", count: 0 },
        { name: "disturbing", count: 0 },
        { name: "horrific", count: 0 },
        { name: "brutal", count: 0 },
        { name: "cope", count: 0 },
        { name: "saddest", count: 0 },
        { name: "devastated", count: 0 },
        { name: "depressed", count: 0 },
        { name: "depressing", count: 0 },
        { name: "terrifying", count: 0 },
        { name: "devastating", count: 0 },
        { name: "excruciating", count: 0 },
        { name: "disturbed", count: 0 },
        { name: "distraught", count: 0 },
        { name: "despair", count: 0 },
        { name: "traumatised", count: 0 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "Rupaul's Drag Race ",
      show_type: "Reality TV",
      show_hashtag: "#rupaulsdragrace ",
      num_stressed_tweets: 160568,
      max_number: 168356,
      stressed_word_counts: [
        { name: "bad", count: 0 },
        { name: "omg", count: 0 },
        { name: "cry", count: 0 },
        { name: "hate", count: 0 },
        { name: "damn", count: 0 },
        { name: "crazy", count: 0 },
        { name: "crying", count: 0 },
        { name: "annoying", count: 0 },
        { name: "sad", count: 0 },
        { name: "horrible", count: 0 },
        { name: "wtf", count: 0 },
        { name: "terrible", count: 0 },
        { name: "awful", count: 0 },
        { name: "sick", count: 0 },
        { name: "disgusting", count: 0 },
        { name: "shock", count: 0 },
        { name: "weird", count: 0 },
        { name: "shocked", count: 0 },
        { name: "crap", count: 0 },
        { name: "emotional", count: 0 },
        { name: "angry", count: 0 },
        { name: "dead", count: 0 },
        { name: "worried", count: 0 },
        { name: "scary", count: 0 },
        { name: "death", count: 0 },
        { name: "screaming", count: 0 },
        { name: "bloody", count: 0 },
        { name: "creepy", count: 0 },
        { name: "killed", count: 0 },
        { name: "died", count: 0 },
        { name: "cried", count: 0 },
        { name: "scared", count: 0 },
        { name: "dark", count: 0 },
        { name: "murder", count: 0 },
        { name: "heartbreaking", count: 0 },
        { name: "disturbing", count: 0 },
        { name: "horrific", count: 0 },
        { name: "brutal", count: 0 },
        { name: "cope", count: 0 },
        { name: "saddest", count: 0 },
        { name: "devastated", count: 0 },
        { name: "depressed", count: 0 },
        { name: "depressing", count: 0 },
        { name: "terrifying", count: 0 },
        { name: "devastating", count: 0 },
        { name: "excruciating", count: 0 },
        { name: "disturbed", count: 0 },
        { name: "distraught", count: 0 },
        { name: "despair", count: 0 },
        { name: "traumatised", count: 0 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "Love Island",
      show_type: "Reality TV",
      show_hashtag: "#loveisland",
      num_stressed_tweets: 155412,
      max_number: 168356,
      stressed_word_counts: [
        { name: "bad", count: 13580 },
        { name: "omg", count: 13826 },
        { name: "cry", count: 18307 },
        { name: "hate", count: 10762 },
        { name: "damn", count: 4616 },
        { name: "crazy", count: 1478 },
        { name: "crying", count: 11805 },
        { name: "annoying", count: 5940 },
        { name: "sad", count: 3710 },
        { name: "horrible", count: 893 },
        { name: "wtf", count: 7762 },
        { name: "terrible", count: 872 },
        { name: "awful", count: 1218 },
        { name: "sick", count: 4313 },
        { name: "disgusting", count: 1849 },
        { name: "shock", count: 2858 },
        { name: "weird", count: 2967 },
        { name: "shocked", count: 1839 },
        { name: "crap", count: 630 },
        { name: "emotional", count: 1103 },
        { name: "angry", count: 2217 },
        { name: "dead", count: 6340 },
        { name: "worried", count: 968 },
        { name: "scary", count: 1758 },
        { name: "death", count: 716 },
        { name: "screaming", count: 2769 },
        { name: "bloody", count: 2105 },
        { name: "creepy", count: 433 },
        { name: "killed", count: 365 },
        { name: "died", count: 631 },
        { name: "cried", count: 680 },
        { name: "scared", count: 2534 },
        { name: "dark", count: 5179 },
        { name: "murder", count: 249 },
        { name: "heartbreaking", count: 126 },
        { name: "disturbing", count: 128 },
        { name: "horrific", count: 110 },
        { name: "brutal", count: 682 },
        { name: "cope", count: 673 },
        { name: "saddest", count: 26 },
        { name: "devastated", count: 174 },
        { name: "depressed", count: 125 },
        { name: "depressing", count: 80 },
        { name: "terrifying", count: 260 },
        { name: "devastating", count: 31 },
        { name: "excruciating", count: 25 },
        { name: "disturbed", count: 36 },
        { name: "distraught", count: 34 },
        { name: "despair", count: 26 },
        { name: "traumatised", count: 60 },
        { name: "morbid", count: 4 },
      ],
    },
    {
      show: "Great British Bake Off",
      show_type: "Reality TV",
      show_hashtag: "#gbbo",
      num_stressed_tweets: 21581,
      max_number: 168356,
      stressed_word_counts: [
        { name: "bad", count: 2051 },
        { name: "omg", count: 1687 },
        { name: "cry", count: 2181 },
        { name: "hate", count: 996 },
        { name: "damn", count: 402 },
        { name: "crazy", count: 224 },
        { name: "crying", count: 1322 },
        { name: "annoying", count: 324 },
        { name: "sad", count: 1323 },
        { name: "horrible", count: 197 },
        { name: "wtf", count: 539 },
        { name: "terrible", count: 459 },
        { name: "awful", count: 467 },
        { name: "sick", count: 186 },
        { name: "disgusting", count: 210 },
        { name: "shock", count: 525 },
        { name: "weird", count: 453 },
        { name: "shocked", count: 309 },
        { name: "crap", count: 309 },
        { name: "emotional", count: 668 },
        { name: "angry", count: 277 },
        { name: "dead", count: 261 },
        { name: "worried", count: 275 },
        { name: "scary", count: 84 },
        { name: "death", count: 155 },
        { name: "screaming", count: 191 },
        { name: "bloody", count: 1224 },
        { name: "creepy", count: 80 },
        { name: "killed", count: 83 },
        { name: "died", count: 118 },
        { name: "cried", count: 304 },
        { name: "scared", count: 106 },
        { name: "dark", count: 385 },
        { name: "murder", count: 130 },
        { name: "heartbreaking", count: 66 },
        { name: "disturbing", count: 27 },
        { name: "horrific", count: 60 },
        { name: "brutal", count: 146 },
        { name: "cope", count: 187 },
        { name: "saddest", count: 10 },
        { name: "devastated", count: 144 },
        { name: "depressed", count: 20 },
        { name: "depressing", count: 46 },
        { name: "terrifying", count: 123 },
        { name: "devastating", count: 33 },
        { name: "excruciating", count: 12 },
        { name: "disturbed", count: 15 },
        { name: "distraught", count: 20 },
        { name: "despair", count: 29 },
        { name: "traumatised", count: 11 },
        { name: "morbid", count: 1 },
      ],
    },
    {
      show: "Stricly Come Dancing",
      show_type: "Reality TV",
      show_hashtag: "#strictly",
      num_stressed_tweets: 16389,
      max_number: 168356,
      stressed_word_counts: [
        { name: "bad", count: 1028 },
        { name: "omg", count: 1526 },
        { name: "cry", count: 1301 },
        { name: "hate", count: 803 },
        { name: "damn", count: 327 },
        { name: "crazy", count: 153 },
        { name: "crying", count: 754 },
        { name: "annoying", count: 317 },
        { name: "sad", count: 1029 },
        { name: "horrible", count: 121 },
        { name: "wtf", count: 325 },
        { name: "terrible", count: 358 },
        { name: "awful", count: 606 },
        { name: "sick", count: 156 },
        { name: "disgusting", count: 50 },
        { name: "shock", count: 398 },
        { name: "weird", count: 425 },
        { name: "shocked", count: 203 },
        { name: "crap", count: 240 },
        { name: "emotional", count: 768 },
        { name: "angry", count: 69 },
        { name: "dead", count: 137 },
        { name: "worried", count: 196 },
        { name: "scary", count: 65 },
        { name: "death", count: 177 },
        { name: "screaming", count: 216 },
        { name: "bloody", count: 1417 },
        { name: "creepy", count: 48 },
        { name: "killed", count: 117 },
        { name: "died", count: 55 },
        { name: "cried", count: 131 },
        { name: "scared", count: 66 },
        { name: "dark", count: 328 },
        { name: "murder", count: 77 },
        { name: "heartbreaking", count: 42 },
        { name: "disturbing", count: 12 },
        { name: "horrific", count: 27 },
        { name: "brutal", count: 21 },
        { name: "cope", count: 127 },
        { name: "saddest", count: 3 },
        { name: "devastated", count: 82 },
        { name: "depressed", count: 19 },
        { name: "depressing", count: 55 },
        { name: "terrifying", count: 29 },
        { name: "devastating", count: 11 },
        { name: "excruciating", count: 3 },
        { name: "disturbed", count: 4 },
        { name: "distraught", count: 6 },
        { name: "despair", count: 16 },
        { name: "traumatised", count: 5 },
        { name: "morbid", count: 1 },
      ],
    },
    {
      show: "Below Deck",
      show_type: "Reality TV",
      show_hashtag: "#belowdeck",
      num_stressed_tweets: 10938,
      max_number: 168356,
      stressed_word_counts: [
        { name: "bad", count: 1194 },
        { name: "omg", count: 977 },
        { name: "cry", count: 817 },
        { name: "hate", count: 697 },
        { name: "damn", count: 611 },
        { name: "crazy", count: 560 },
        { name: "crying", count: 550 },
        { name: "annoying", count: 393 },
        { name: "sad", count: 387 },
        { name: "horrible", count: 336 },
        { name: "wtf", count: 327 },
        { name: "terrible", count: 309 },
        { name: "awful", count: 306 },
        { name: "sick", count: 298 },
        { name: "disgusting", count: 290 },
        { name: "shock", count: 259 },
        { name: "weird", count: 249 },
        { name: "shocked", count: 200 },
        { name: "crap", count: 144 },
        { name: "emotional", count: 116 },
        { name: "angry", count: 116 },
        { name: "dead", count: 94 },
        { name: "worried", count: 86 },
        { name: "scary", count: 75 },
        { name: "death", count: 67 },
        { name: "screaming", count: 67 },
        { name: "bloody", count: 66 },
        { name: "creepy", count: 65 },
        { name: "killed", count: 64 },
        { name: "died", count: 60 },
        { name: "cried", count: 48 },
        { name: "scared", count: 47 },
        { name: "dark", count: 42 },
        { name: "murder", count: 42 },
        { name: "heartbreaking", count: 37 },
        { name: "disturbing", count: 26 },
        { name: "horrific", count: 25 },
        { name: "brutal", count: 21 },
        { name: "cope", count: 13 },
        { name: "saddest", count: 11 },
        { name: "devastated", count: 9 },
        { name: "depressed", count: 9 },
        { name: "depressing", count: 8 },
        { name: "terrifying", count: 5 },
        { name: "devastating", count: 4 },
        { name: "excruciating", count: 4 },
        { name: "disturbed", count: 3 },
        { name: "distraught", count: 2 },
        { name: "despair", count: 0 },
        { name: "traumatised", count: 0 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "Selling Sunset",
      show_type: "Reality TV",
      show_hashtag: "#sellingsunset",
      num_stressed_tweets: 6080,
      max_number: 168356,
      stressed_word_counts: [
        { name: "bad", count: 585 },
        { name: "omg", count: 598 },
        { name: "cry", count: 335 },
        { name: "hate", count: 845 },
        { name: "damn", count: 314 },
        { name: "crazy", count: 126 },
        { name: "crying", count: 228 },
        { name: "annoying", count: 333 },
        { name: "sad", count: 207 },
        { name: "horrible", count: 215 },
        { name: "wtf", count: 168 },
        { name: "terrible", count: 150 },
        { name: "awful", count: 200 },
        { name: "sick", count: 63 },
        { name: "disgusting", count: 117 },
        { name: "shock", count: 77 },
        { name: "weird", count: 209 },
        { name: "shocked", count: 58 },
        { name: "crap", count: 41 },
        { name: "emotional", count: 56 },
        { name: "angry", count: 47 },
        { name: "dead", count: 72 },
        { name: "worried", count: 21 },
        { name: "scary", count: 20 },
        { name: "death", count: 27 },
        { name: "screaming", count: 36 },
        { name: "bloody", count: 45 },
        { name: "creepy", count: 16 },
        { name: "killed", count: 15 },
        { name: "died", count: 38 },
        { name: "cried", count: 68 },
        { name: "scared", count: 22 },
        { name: "dark", count: 28 },
        { name: "murder", count: 9 },
        { name: "heartbreaking", count: 46 },
        { name: "disturbing", count: 4 },
        { name: "horrific", count: 4 },
        { name: "brutal", count: 18 },
        { name: "cope", count: 17 },
        { name: "saddest", count: 5 },
        { name: "devastated", count: 14 },
        { name: "depressed", count: 6 },
        { name: "depressing", count: 6 },
        { name: "terrifying", count: 8 },
        { name: "devastating", count: 11 },
        { name: "excruciating", count: 0 },
        { name: "disturbed", count: 3 },
        { name: "distraught", count: 0 },
        { name: "despair", count: 0 },
        { name: "traumatised", count: 3 },
        { name: "morbid", count: 1 },
      ],
    },
    {
      show: "The Only Way is Essex",
      show_type: "Reality TV",
      show_hashtag: "#towie",
      num_stressed_tweets: 4578,
      max_number: 168356,
      stressed_word_counts: [
        { name: "bad", count: 405 },
        { name: "omg", count: 425 },
        { name: "cry", count: 432 },
        { name: "hate", count: 266 },
        { name: "damn", count: 101 },
        { name: "crazy", count: 65 },
        { name: "crying", count: 310 },
        { name: "annoying", count: 157 },
        { name: "sad", count: 182 },
        { name: "horrible", count: 138 },
        { name: "wtf", count: 156 },
        { name: "terrible", count: 31 },
        { name: "awful", count: 92 },
        { name: "sick", count: 82 },
        { name: "disgusting", count: 120 },
        { name: "shock", count: 116 },
        { name: "weird", count: 157 },
        { name: "shocked", count: 72 },
        { name: "crap", count: 53 },
        { name: "emotional", count: 107 },
        { name: "angry", count: 66 },
        { name: "dead", count: 90 },
        { name: "worried", count: 24 },
        { name: "scary", count: 20 },
        { name: "death", count: 52 },
        { name: "screaming", count: 52 },
        { name: "bloody", count: 183 },
        { name: "creepy", count: 12 },
        { name: "killed", count: 16 },
        { name: "died", count: 34 },
        { name: "cried", count: 51 },
        { name: "scared", count: 82 },
        { name: "dark", count: 6 },
        { name: "murder", count: 2 },
        { name: "heartbreaking", count: 19 },
        { name: "disturbing", count: 6 },
        { name: "horrific", count: 9 },
        { name: "brutal", count: 11 },
        { name: "cope", count: 56 },
        { name: "saddest", count: 0 },
        { name: "devastated", count: 3 },
        { name: "depressed", count: 2 },
        { name: "depressing", count: 6 },
        { name: "terrifying", count: 3 },
        { name: "devastating", count: 5 },
        { name: "excruciating", count: 0 },
        { name: "disturbed", count: 0 },
        { name: "distraught", count: 0 },
        { name: "despair", count: 0 },
        { name: "traumatised", count: 2 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "SAS Who Dares Wins",
      show_type: "Reality TV",
      show_hashtag: "#saswhodareswins",
      num_stressed_tweets: 942,
      max_number: 168356,
      stressed_word_counts: [
        { name: "bad", count: 39 },
        { name: "omg", count: 38 },
        { name: "cry", count: 49 },
        { name: "hate", count: 28 },
        { name: "damn", count: 18 },
        { name: "crazy", count: 8 },
        { name: "crying", count: 30 },
        { name: "annoying", count: 4 },
        { name: "sad", count: 49 },
        { name: "horrible", count: 13 },
        { name: "wtf", count: 14 },
        { name: "terrible", count: 7 },
        { name: "awful", count: 14 },
        { name: "sick", count: 14 },
        { name: "disgusting", count: 6 },
        { name: "shock", count: 20 },
        { name: "weird", count: 9 },
        { name: "shocked", count: 17 },
        { name: "crap", count: 10 },
        { name: "emotional", count: 28 },
        { name: "angry", count: 10 },
        { name: "dead", count: 75 },
        { name: "worried", count: 3 },
        { name: "scary", count: 11 },
        { name: "death", count: 20 },
        { name: "screaming", count: 12 },
        { name: "bloody", count: 68 },
        { name: "creepy", count: 1 },
        { name: "killed", count: 10 },
        { name: "died", count: 8 },
        { name: "cried", count: 2 },
        { name: "scared", count: 14 },
        { name: "dark", count: 36 },
        { name: "murder", count: 11 },
        { name: "heartbreaking", count: 24 },
        { name: "disturbing", count: 2 },
        { name: "horrific", count: 9 },
        { name: "brutal", count: 85 },
        { name: "cope", count: 9 },
        { name: "saddest", count: 0 },
        { name: "devastated", count: 3 },
        { name: "depressed", count: 0 },
        { name: "depressing", count: 0 },
        { name: "terrifying", count: 22 },
        { name: "devastating", count: 1 },
        { name: "excruciating", count: 0 },
        { name: "disturbed", count: 0 },
        { name: "distraught", count: 0 },
        { name: "despair", count: 0 },
        { name: "traumatised", count: 0 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "Made in Chelsea",
      show_type: "Reality TV",
      show_hashtag: "#mic",
      num_stressed_tweets: 919,
      max_number: 168356,
      stressed_word_counts: [
        { name: "bad", count: 85 },
        { name: "omg", count: 51 },
        { name: "cry", count: 78 },
        { name: "hate", count: 44 },
        { name: "damn", count: 25 },
        { name: "crazy", count: 20 },
        { name: "crying", count: 52 },
        { name: "annoying", count: 15 },
        { name: "sad", count: 28 },
        { name: "horrible", count: 7 },
        { name: "wtf", count: 17 },
        { name: "terrible", count: 8 },
        { name: "awful", count: 14 },
        { name: "sick", count: 14 },
        { name: "disgusting", count: 6 },
        { name: "shock", count: 37 },
        { name: "weird", count: 23 },
        { name: "shocked", count: 5 },
        { name: "crap", count: 9 },
        { name: "emotional", count: 23 },
        { name: "angry", count: 12 },
        { name: "dead", count: 53 },
        { name: "worried", count: 11 },
        { name: "scary", count: 3 },
        { name: "death", count: 47 },
        { name: "screaming", count: 5 },
        { name: "bloody", count: 12 },
        { name: "creepy", count: 11 },
        { name: "killed", count: 14 },
        { name: "died", count: 10 },
        { name: "cried", count: 8 },
        { name: "scared", count: 13 },
        { name: "dark", count: 27 },
        { name: "murder", count: 32 },
        { name: "heartbreaking", count: 1 },
        { name: "disturbing", count: 1 },
        { name: "horrific", count: 3 },
        { name: "brutal", count: 12 },
        { name: "cope", count: 5 },
        { name: "saddest", count: 0 },
        { name: "devastated", count: 4 },
        { name: "depressed", count: 1 },
        { name: "depressing", count: 2 },
        { name: "terrifying", count: 0 },
        { name: "devastating", count: 2 },
        { name: "excruciating", count: 1 },
        { name: "disturbed", count: 0 },
        { name: "distraught", count: 0 },
        { name: "despair", count: 0 },
        { name: "traumatised", count: 0 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "Squid Game",
      show_type: "TV Drama",
      show_hashtag: "#squidgame",
      num_stressed_tweets: 190897,
      max_number: 190897,
      stressed_word_counts: [
        { name: "bad", count: 0 },
        { name: "omg", count: 0 },
        { name: "cry", count: 0 },
        { name: "hate", count: 0 },
        { name: "damn", count: 0 },
        { name: "crazy", count: 0 },
        { name: "crying", count: 0 },
        { name: "annoying", count: 0 },
        { name: "sad", count: 0 },
        { name: "horrible", count: 0 },
        { name: "wtf", count: 0 },
        { name: "terrible", count: 0 },
        { name: "awful", count: 0 },
        { name: "sick", count: 0 },
        { name: "disgusting", count: 0 },
        { name: "shock", count: 0 },
        { name: "weird", count: 0 },
        { name: "shocked", count: 0 },
        { name: "crap", count: 0 },
        { name: "emotional", count: 0 },
        { name: "angry", count: 0 },
        { name: "dead", count: 0 },
        { name: "worried", count: 0 },
        { name: "scary", count: 0 },
        { name: "death", count: 0 },
        { name: "screaming", count: 0 },
        { name: "bloody", count: 0 },
        { name: "creepy", count: 0 },
        { name: "killed", count: 0 },
        { name: "died", count: 0 },
        { name: "cried", count: 0 },
        { name: "scared", count: 0 },
        { name: "dark", count: 0 },
        { name: "murder", count: 0 },
        { name: "heartbreaking", count: 0 },
        { name: "disturbing", count: 0 },
        { name: "horrific", count: 0 },
        { name: "brutal", count: 0 },
        { name: "cope", count: 0 },
        { name: "saddest", count: 0 },
        { name: "devastated", count: 0 },
        { name: "depressed", count: 0 },
        { name: "depressing", count: 0 },
        { name: "terrifying", count: 0 },
        { name: "devastating", count: 0 },
        { name: "excruciating", count: 0 },
        { name: "disturbed", count: 0 },
        { name: "distraught", count: 0 },
        { name: "despair", count: 0 },
        { name: "traumatised", count: 0 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "Sex Education",
      show_type: "TV Drama",
      show_hashtag: "#sexeducation",
      num_stressed_tweets: 57256,
      max_number: 190897,
      stressed_word_counts: [
        { name: "bad", count: 0 },
        { name: "omg", count: 0 },
        { name: "cry", count: 0 },
        { name: "hate", count: 0 },
        { name: "damn", count: 0 },
        { name: "crazy", count: 0 },
        { name: "crying", count: 0 },
        { name: "annoying", count: 0 },
        { name: "sad", count: 0 },
        { name: "horrible", count: 0 },
        { name: "wtf", count: 0 },
        { name: "terrible", count: 0 },
        { name: "awful", count: 0 },
        { name: "sick", count: 0 },
        { name: "disgusting", count: 0 },
        { name: "shock", count: 0 },
        { name: "weird", count: 0 },
        { name: "shocked", count: 0 },
        { name: "crap", count: 0 },
        { name: "emotional", count: 0 },
        { name: "angry", count: 0 },
        { name: "dead", count: 0 },
        { name: "worried", count: 0 },
        { name: "scary", count: 0 },
        { name: "death", count: 0 },
        { name: "screaming", count: 0 },
        { name: "bloody", count: 0 },
        { name: "creepy", count: 0 },
        { name: "killed", count: 0 },
        { name: "died", count: 0 },
        { name: "cried", count: 0 },
        { name: "scared", count: 0 },
        { name: "dark", count: 0 },
        { name: "murder", count: 0 },
        { name: "heartbreaking", count: 0 },
        { name: "disturbing", count: 0 },
        { name: "horrific", count: 0 },
        { name: "brutal", count: 0 },
        { name: "cope", count: 0 },
        { name: "saddest", count: 0 },
        { name: "devastated", count: 0 },
        { name: "depressed", count: 0 },
        { name: "depressing", count: 0 },
        { name: "terrifying", count: 0 },
        { name: "devastating", count: 0 },
        { name: "excruciating", count: 0 },
        { name: "disturbed", count: 0 },
        { name: "distraught", count: 0 },
        { name: "despair", count: 0 },
        { name: "traumatised", count: 0 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "Lucifer",
      show_type: "TV Drama",
      show_hashtag: "#lucifer",
      num_stressed_tweets: 52025,
      max_number: 190897,
      stressed_word_counts: [
        { name: "bad", count: 0 },
        { name: "omg", count: 0 },
        { name: "cry", count: 0 },
        { name: "hate", count: 0 },
        { name: "damn", count: 0 },
        { name: "crazy", count: 0 },
        { name: "crying", count: 0 },
        { name: "annoying", count: 0 },
        { name: "sad", count: 0 },
        { name: "horrible", count: 0 },
        { name: "wtf", count: 0 },
        { name: "terrible", count: 0 },
        { name: "awful", count: 0 },
        { name: "sick", count: 0 },
        { name: "disgusting", count: 0 },
        { name: "shock", count: 0 },
        { name: "weird", count: 0 },
        { name: "shocked", count: 0 },
        { name: "crap", count: 0 },
        { name: "emotional", count: 0 },
        { name: "angry", count: 0 },
        { name: "dead", count: 0 },
        { name: "worried", count: 0 },
        { name: "scary", count: 0 },
        { name: "death", count: 0 },
        { name: "screaming", count: 0 },
        { name: "bloody", count: 0 },
        { name: "creepy", count: 0 },
        { name: "killed", count: 0 },
        { name: "died", count: 0 },
        { name: "cried", count: 0 },
        { name: "scared", count: 0 },
        { name: "dark", count: 0 },
        { name: "murder", count: 0 },
        { name: "heartbreaking", count: 0 },
        { name: "disturbing", count: 0 },
        { name: "horrific", count: 0 },
        { name: "brutal", count: 0 },
        { name: "cope", count: 0 },
        { name: "saddest", count: 0 },
        { name: "devastated", count: 0 },
        { name: "depressed", count: 0 },
        { name: "depressing", count: 0 },
        { name: "terrifying", count: 0 },
        { name: "devastating", count: 0 },
        { name: "excruciating", count: 0 },
        { name: "disturbed", count: 0 },
        { name: "distraught", count: 0 },
        { name: "despair", count: 0 },
        { name: "traumatised", count: 0 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "American Horror Story",
      show_type: "TV Drama",
      show_hashtag: "#americanhorrorstory",
      num_stressed_tweets: 50657,
      max_number: 190897,
      stressed_word_counts: [
        { name: "bad", count: 0 },
        { name: "omg", count: 0 },
        { name: "cry", count: 0 },
        { name: "hate", count: 0 },
        { name: "damn", count: 0 },
        { name: "crazy", count: 0 },
        { name: "crying", count: 0 },
        { name: "annoying", count: 0 },
        { name: "sad", count: 0 },
        { name: "horrible", count: 0 },
        { name: "wtf", count: 0 },
        { name: "terrible", count: 0 },
        { name: "awful", count: 0 },
        { name: "sick", count: 0 },
        { name: "disgusting", count: 0 },
        { name: "shock", count: 0 },
        { name: "weird", count: 0 },
        { name: "shocked", count: 0 },
        { name: "crap", count: 0 },
        { name: "emotional", count: 0 },
        { name: "angry", count: 0 },
        { name: "dead", count: 0 },
        { name: "worried", count: 0 },
        { name: "scary", count: 0 },
        { name: "death", count: 0 },
        { name: "screaming", count: 0 },
        { name: "bloody", count: 0 },
        { name: "creepy", count: 0 },
        { name: "killed", count: 0 },
        { name: "died", count: 0 },
        { name: "cried", count: 0 },
        { name: "scared", count: 0 },
        { name: "dark", count: 0 },
        { name: "murder", count: 0 },
        { name: "heartbreaking", count: 0 },
        { name: "disturbing", count: 0 },
        { name: "horrific", count: 0 },
        { name: "brutal", count: 0 },
        { name: "cope", count: 0 },
        { name: "saddest", count: 0 },
        { name: "devastated", count: 0 },
        { name: "depressed", count: 0 },
        { name: "depressing", count: 0 },
        { name: "terrifying", count: 0 },
        { name: "devastating", count: 0 },
        { name: "excruciating", count: 0 },
        { name: "disturbed", count: 0 },
        { name: "distraught", count: 0 },
        { name: "despair", count: 0 },
        { name: "traumatised", count: 0 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "Ted Lasso",
      show_type: "TV Drama",
      show_hashtag: "#tedlasso",
      num_stressed_tweets: 48354,
      max_number: 190897,
      stressed_word_counts: [
        { name: "bad", count: 0 },
        { name: "omg", count: 0 },
        { name: "cry", count: 0 },
        { name: "hate", count: 0 },
        { name: "damn", count: 0 },
        { name: "crazy", count: 0 },
        { name: "crying", count: 0 },
        { name: "annoying", count: 0 },
        { name: "sad", count: 0 },
        { name: "horrible", count: 0 },
        { name: "wtf", count: 0 },
        { name: "terrible", count: 0 },
        { name: "awful", count: 0 },
        { name: "sick", count: 0 },
        { name: "disgusting", count: 0 },
        { name: "shock", count: 0 },
        { name: "weird", count: 0 },
        { name: "shocked", count: 0 },
        { name: "crap", count: 0 },
        { name: "emotional", count: 0 },
        { name: "angry", count: 0 },
        { name: "dead", count: 0 },
        { name: "worried", count: 0 },
        { name: "scary", count: 0 },
        { name: "death", count: 0 },
        { name: "screaming", count: 0 },
        { name: "bloody", count: 0 },
        { name: "creepy", count: 0 },
        { name: "killed", count: 0 },
        { name: "died", count: 0 },
        { name: "cried", count: 0 },
        { name: "scared", count: 0 },
        { name: "dark", count: 0 },
        { name: "murder", count: 0 },
        { name: "heartbreaking", count: 0 },
        { name: "disturbing", count: 0 },
        { name: "horrific", count: 0 },
        { name: "brutal", count: 0 },
        { name: "cope", count: 0 },
        { name: "saddest", count: 0 },
        { name: "devastated", count: 0 },
        { name: "depressed", count: 0 },
        { name: "depressing", count: 0 },
        { name: "terrifying", count: 0 },
        { name: "devastating", count: 0 },
        { name: "excruciating", count: 0 },
        { name: "disturbed", count: 0 },
        { name: "distraught", count: 0 },
        { name: "despair", count: 0 },
        { name: "traumatised", count: 0 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "The Walking Dead",
      show_type: "TV Drama",
      show_hashtag: "#twd",
      num_stressed_tweets: 46088,
      max_number: 190897,
      stressed_word_counts: [
        { name: "bad", count: 1523 },
        { name: "omg", count: 1239 },
        { name: "cry", count: 848 },
        { name: "hate", count: 888 },
        { name: "damn", count: 1420 },
        { name: "crazy", count: 512 },
        { name: "crying", count: 440 },
        { name: "annoying", count: 181 },
        { name: "sad", count: 1001 },
        { name: "horrible", count: 104 },
        { name: "wtf", count: 422 },
        { name: "terrible", count: 143 },
        { name: "awful", count: 109 },
        { name: "sick", count: 238 },
        { name: "disgusting", count: 49 },
        { name: "shock", count: 199 },
        { name: "weird", count: 259 },
        { name: "shocked", count: 72 },
        { name: "crap", count: 226 },
        { name: "emotional", count: 389 },
        { name: "angry", count: 90 },
        { name: "dead", count: 41198 },
        { name: "worried", count: 130 },
        { name: "scary", count: 360 },
        { name: "death", count: 1020 },
        { name: "screaming", count: 100 },
        { name: "bloody", count: 138 },
        { name: "creepy", count: 156 },
        { name: "killed", count: 1129 },
        { name: "died", count: 661 },
        { name: "cried", count: 164 },
        { name: "scared", count: 241 },
        { name: "dark", count: 345 },
        { name: "murder", count: 116 },
        { name: "heartbreaking", count: 145 },
        { name: "disturbing", count: 26 },
        { name: "horrific", count: 21 },
        { name: "brutal", count: 119 },
        { name: "cope", count: 65 },
        { name: "saddest", count: 57 },
        { name: "devastated", count: 27 },
        { name: "depressed", count: 20 },
        { name: "depressing", count: 38 },
        { name: "terrifying", count: 75 },
        { name: "devastating", count: 13 },
        { name: "excruciating", count: 3 },
        { name: "disturbed", count: 6 },
        { name: "distraught", count: 8 },
        { name: "despair", count: 10 },
        { name: "traumatised", count: 4 },
        { name: "morbid", count: 2 },
      ],
    },
    {
      show: "Loki",
      show_type: "TV Drama",
      show_hashtag: "#loki",
      num_stressed_tweets: 34678,
      max_number: 190897,
      stressed_word_counts: [
        { name: "bad", count: 6519 },
        { name: "omg", count: 10323 },
        { name: "cry", count: 7191 },
        { name: "hate", count: 4007 },
        { name: "damn", count: 5119 },
        { name: "crazy", count: 2497 },
        { name: "crying", count: 3978 },
        { name: "annoying", count: 512 },
        { name: "sad", count: 3317 },
        { name: "horrible", count: 333 },
        { name: "wtf", count: 6013 },
        { name: "terrible", count: 474 },
        { name: "awful", count: 275 },
        { name: "sick", count: 1076 },
        { name: "disgusting", count: 243 },
        { name: "shock", count: 1293 },
        { name: "weird", count: 2570 },
        { name: "shocked", count: 495 },
        { name: "crap", count: 566 },
        { name: "emotional", count: 1823 },
        { name: "angry", count: 491 },
        { name: "dead", count: 2397 },
        { name: "worried", count: 340 },
        { name: "scary", count: 350 },
        { name: "death", count: 2475 },
        { name: "screaming", count: 1376 },
        { name: "bloody", count: 382 },
        { name: "creepy", count: 333 },
        { name: "killed", count: 2418 },
        { name: "died", count: 1852 },
        { name: "cried", count: 1167 },
        { name: "scared", count: 1633 },
        { name: "dark", count: 1707 },
        { name: "murder", count: 225 },
        { name: "heartbreaking", count: 334 },
        { name: "disturbing", count: 58 },
        { name: "horrific", count: 32 },
        { name: "brutal", count: 635 },
        { name: "cope", count: 136 },
        { name: "saddest", count: 86 },
        { name: "devastated", count: 135 },
        { name: "depressed", count: 125 },
        { name: "depressing", count: 93 },
        { name: "terrifying", count: 280 },
        { name: "devastating", count: 47 },
        { name: "excruciating", count: 9 },
        { name: "disturbed", count: 31 },
        { name: "distraught", count: 55 },
        { name: "despair", count: 44 },
        { name: "traumatised", count: 21 },
        { name: "morbid", count: 3 },
      ],
    },
    {
      show: "Stranger Things",
      show_type: "TV Drama",
      show_hashtag: "#strangerthings",
      num_stressed_tweets: 33456,
      max_number: 190897,
      stressed_word_counts: [
        { name: "bad", count: 283 },
        { name: "omg", count: 325 },
        { name: "cry", count: 152 },
        { name: "hate", count: 118 },
        { name: "damn", count: 153 },
        { name: "crazy", count: 161 },
        { name: "crying", count: 63 },
        { name: "annoying", count: 45 },
        { name: "sad", count: 190 },
        { name: "horrible", count: 22 },
        { name: "wtf", count: 94 },
        { name: "terrible", count: 19 },
        { name: "awful", count: 21 },
        { name: "sick", count: 30 },
        { name: "disgusting", count: 18 },
        { name: "shock", count: 36 },
        { name: "weird", count: 344 },
        { name: "shocked", count: 10 },
        { name: "crap", count: 31 },
        { name: "emotional", count: 35 },
        { name: "angry", count: 31 },
        { name: "dead", count: 497 },
        { name: "worried", count: 19 },
        { name: "scary", count: 141 },
        { name: "death", count: 114 },
        { name: "screaming", count: 19 },
        { name: "bloody", count: 35 },
        { name: "creepy", count: 183 },
        { name: "killed", count: 53 },
        { name: "died", count: 95 },
        { name: "cried", count: 47 },
        { name: "scared", count: 38 },
        { name: "dark", count: 665 },
        { name: "murder", count: 53 },
        { name: "heartbreaking", count: 6 },
        { name: "disturbing", count: 6 },
        { name: "horrific", count: 8 },
        { name: "brutal", count: 17 },
        { name: "cope", count: 7 },
        { name: "saddest", count: 4 },
        { name: "devastated", count: 2 },
        { name: "depressed", count: 1 },
        { name: "depressing", count: 3 },
        { name: "terrifying", count: 15 },
        { name: "devastating", count: 4 },
        { name: "excruciating", count: 1 },
        { name: "disturbed", count: 17 },
        { name: "distraught", count: 0 },
        { name: "despair", count: 1 },
        { name: "traumatised", count: 1 },
        { name: "morbid", count: 0 },
      ],
    },
    {
      show: "Handmaid's Tale",
      show_type: "TV Drama",
      show_hashtag: "#handmaidstale",
      num_stressed_tweets: 13283,
      max_number: 190897,
      stressed_word_counts: [
        { name: "bad", count: 691 },
        { name: "omg", count: 1345 },
        { name: "cry", count: 807 },
        { name: "hate", count: 810 },
        { name: "damn", count: 1237 },
        { name: "crazy", count: 487 },
        { name: "crying", count: 509 },
        { name: "annoying", count: 250 },
        { name: "sad", count: 300 },
        { name: "horrible", count: 95 },
        { name: "wtf", count: 568 },
        { name: "terrible", count: 92 },
        { name: "awful", count: 76 },
        { name: "sick", count: 391 },
        { name: "disgusting", count: 104 },
        { name: "shock", count: 198 },
        { name: "weird", count: 180 },
        { name: "shocked", count: 89 },
        { name: "crap", count: 68 },
        { name: "emotional", count: 313 },
        { name: "angry", count: 158 },
        { name: "dead", count: 502 },
        { name: "worried", count: 97 },
        { name: "scary", count: 202 },
        { name: "death", count: 301 },
        { name: "screaming", count: 171 },
        { name: "bloody", count: 96 },
        { name: "creepy", count: 93 },
        { name: "killed", count: 358 },
        { name: "died", count: 124 },
        { name: "cried", count: 158 },
        { name: "scared", count: 210 },
        { name: "dark", count: 267 },
        { name: "murder", count: 92 },
        { name: "heartbreaking", count: 69 },
        { name: "disturbing", count: 112 },
        { name: "horrific", count: 42 },
        { name: "brutal", count: 185 },
        { name: "cope", count: 45 },
        { name: "saddest", count: 11 },
        { name: "devastated", count: 23 },
        { name: "depressed", count: 19 },
        { name: "depressing", count: 65 },
        { name: "terrifying", count: 130 },
        { name: "devastating", count: 17 },
        { name: "excruciating", count: 3 },
        { name: "disturbed", count: 19 },
        { name: "distraught", count: 12 },
        { name: "despair", count: 10 },
        { name: "traumatised", count: 25 },
        { name: "morbid", count: 7 },
      ],
    },
    {
      show: "Bridgerton",
      show_type: "TV Drama",
      show_hashtag: "#bridgerton",
      num_stressed_tweets: 7659,
      max_number: 190897,
      stressed_word_counts: [
        { name: "bad", count: 1779 },
        { name: "omg", count: 2366 },
        { name: "cry", count: 885 },
        { name: "hate", count: 1252 },
        { name: "damn", count: 1842 },
        { name: "crazy", count: 375 },
        { name: "crying", count: 508 },
        { name: "annoying", count: 566 },
        { name: "sad", count: 880 },
        { name: "horrible", count: 184 },
        { name: "wtf", count: 448 },
        { name: "terrible", count: 247 },
        { name: "awful", count: 250 },
        { name: "sick", count: 193 },
        { name: "disgusting", count: 84 },
        { name: "shock", count: 493 },
        { name: "weird", count: 338 },
        { name: "shocked", count: 279 },
        { name: "crap", count: 117 },
        { name: "emotional", count: 254 },
        { name: "angry", count: 170 },
        { name: "dead", count: 581 },
        { name: "worried", count: 129 },
        { name: "scary", count: 36 },
        { name: "death", count: 317 },
        { name: "screaming", count: 313 },
        { name: "bloody", count: 306 },
        { name: "creepy", count: 85 },
        { name: "killed", count: 179 },
        { name: "died", count: 229 },
        { name: "cried", count: 132 },
        { name: "scared", count: 115 },
        { name: "dark", count: 498 },
        { name: "murder", count: 133 },
        { name: "heartbreaking", count: 82 },
        { name: "disturbing", count: 36 },
        { name: "horrific", count: 16 },
        { name: "brutal", count: 29 },
        { name: "cope", count: 48 },
        { name: "saddest", count: 14 },
        { name: "devastated", count: 64 },
        { name: "depressed", count: 26 },
        { name: "depressing", count: 18 },
        { name: "terrifying", count: 57 },
        { name: "devastating", count: 17 },
        { name: "excruciating", count: 13 },
        { name: "disturbed", count: 13 },
        { name: "distraught", count: 14 },
        { name: "despair", count: 7 },
        { name: "traumatised", count: 8 },
        { name: "morbid", count: 2 },
      ],
    },
  ],
};
export default data;
